// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { wsc } from '../wsc';
import { UploadResponse } from '@ay-nestjs/share-client';
import { Observable } from 'rxjs';
import { CreateExport } from './dto/create-export.dto';
import { UsedResponse } from './dto/user-response.dto';

export class PortModel {
  static used(type: string, id: string): Promise<UsedResponse[]> {
    return wsc.execute('/ws/port/used', type, id) as any;
  }

  static uploadFile(
    /** 檔案名稱 */
    filename: string,
    /** 檔案 */
    file: File,
  ): Observable<UploadResponse<string>> {
    return wsc.upload('/ws/port/uploadFile', filename, file) as any;
  }

  static import(
    url: string = '',
    botId: number = null,
    actions: {
      type: string;
      originalId: string | number;
      importId: string | number;
      action: 'RENAME' | 'OVERWRITE' | 'USE_ORIGIN' | 'MERGE';
      name?: string;
    }[] = [],
    _urlType: 'json' | 'zip' = 'json',
    _actualUrl: string = '',
  ): Observable<number> {
    return wsc.subscribe(
      '/ws/port/import',
      url,
      botId,
      actions,
      _urlType,
      _actualUrl,
    ) as any;
  }

  static create(
    data: CreateExport,
  ): Promise<{ id: number; url: string; zipUrl: string }> {
    return wsc.execute('/ws/port/create', data) as any;
  }

  static publish(): Promise<any> {
    return wsc.execute('/ws/port/publish') as any;
  }

  static my(): Promise<any> {
    return wsc.execute('/ws/port/my') as any;
  }

  static fetch(url: string): Promise<any> {
    return wsc.execute('/ws/port/fetch', url) as any;
  }

  static fetchName(type: string, id: string): Promise<any> {
    return wsc.execute('/ws/port/fetchName', type, id) as any;
  }
}
// 5e8263e443ae1bfa4be0dfcc122ceadd92b6efa5ae3a4d30c52cdd4e7c5f810a
